import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import ChevronRight from '@atlaskit/icon/glyph/chevron-right';
import { RESIZE_BUTTON_SELECTOR } from '../../common/constants';
import { increaseHitArea, resizeIconButtonCSS } from './styles';

var preventDefault = function preventDefault(event) {
  return event.preventDefault();
};

var cssSelector = _defineProperty({}, RESIZE_BUTTON_SELECTOR, true);

var ResizeButton = function ResizeButton(_ref) {
  var isLeftSidebarCollapsed = _ref.isLeftSidebarCollapsed,
      label = _ref.label,
      testId = _ref.testId,
      props = _objectWithoutProperties(_ref, ["isLeftSidebarCollapsed", "label", "testId"]);

  return jsx("button", _extends({}, cssSelector, {
    // DO NOT remove. used as a CSS selector.
    "aria-expanded": !isLeftSidebarCollapsed,
    "aria-label": label,
    type: "button",
    css: resizeIconButtonCSS(isLeftSidebarCollapsed),
    "data-testid": testId // Prevents focus staying attached to the button
    // when pressed
    ,
    onMouseDown: preventDefault
  }, props), jsx(ChevronRight, {
    label: ""
  }), jsx("div", {
    css: increaseHitArea
  }));
};

export default ResizeButton;